// fetch.ts
const ACC_KEY = "c5fb349da68ab8094c07a799e99e09ce";
const API_URL = "https://www.powerlego.com/ApiGateway/";


export const fetchBillReader = async (val: any) => {
    
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

    const formdata = new FormData();
    formdata.append("file", val);

    const response = await fetch(`${API_URL}v1/bill_reader`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    })
    return response.json()
}

export const fetchAIChat = async (str: any) =>{
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

    const formdata = new FormData();
    formdata.append("type", "bill_summary");
    formdata.append("message", str)

    const response = await fetch(`${API_URL}v2/openai/chat`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    })
    return response.json()
}
//fetch email
export const contactUs = async (val:any) => {
    let {site , name , email , company , _message} = val;
    const _site = site.toString().replace(/#/, '');
    const _name = name.toString().replace(/#/, '')
    const _email = email.toString().replace(/#/, '')
    const _company = company.toString().replace(/#/, '')
    const message = _message.toString().replace(/#/, '')

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

    const formdata = new FormData();
    formdata.append("site", _site);
    formdata.append("name", _name);
    formdata.append("email", _email);
    formdata.append("company", _company);
    formdata.append("message", message);

    const response = await fetch(`https://www.powerlego.com/contact/website`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    })
    return response.json()
}

export const fetchBillReaderV2 =async (val:any)=>{
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer 9a2e0118239b7ac2f8a024cae140fdc7`);

    const formdata = new FormData();
    formdata.append("file", val);

    const response = await fetch(`${API_URL}v1/bill_reader_v2`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    })
    return response.json()
}

export const fetchSendEmailCode = async (email: any) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
  myHeaders.append("Content-Type", "application/json");

  const requestBody = JSON.stringify({
    contact: email,
    type: "email",
  });

  const requestOptions :any = {
    method: "POST",
    headers: myHeaders,
    body: requestBody,
    redirect: "follow",
  };

  const url = `${API_URL}v2/two_factor/sendcode`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const getVerifyCode = async (type: any, contact: any, code: any) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
  myHeaders.append("Content-Type", "application/json");

  const requestBody = JSON.stringify({
    contact: contact,
    type: type,
    code: code,
  });

  const requestOptions: any = {
    method: "POST",
    headers: myHeaders,
    body: requestBody,
    redirect: "follow",
  };

  const url = `${API_URL}v2/two_factor/verifyCode`;
  const response = await fetch(url, requestOptions);
  return response.json();
};
